import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ListingStats {
  views: Record<string, number>;
  inquiries: Record<string, number>;
}

interface ListingStatsStore extends ListingStats {
  incrementViews: (listingId: string) => void;
  incrementInquiries: (listingId: string) => void;
  getStats: (listingId: string) => { views: number; inquiries: number };
  getTotalStats: () => { totalViews: number; totalInquiries: number };
  resetStore: () => void;
}

const initialState = {
  views: {},
  inquiries: {}
};

export const useListingStats = create<ListingStatsStore>()(
  persist(
    (set, get) => ({
      ...initialState,

      incrementViews: (listingId: string) => 
        set((state) => ({
          views: {
            ...state.views,
            [listingId]: (state.views[listingId] || 0) + 1
          }
        })),

      incrementInquiries: (listingId: string) =>
        set((state) => ({
          inquiries: {
            ...state.inquiries,
            [listingId]: (state.inquiries[listingId] || 0) + 1
          }
        })),

      getStats: (listingId: string) => ({
        views: get().views[listingId] || 0,
        inquiries: get().inquiries[listingId] || 0
      }),

      getTotalStats: () => ({
        totalViews: Object.values(get().views).reduce((sum, count) => sum + count, 0),
        totalInquiries: Object.values(get().inquiries).reduce((sum, count) => sum + count, 0)
      }),

      resetStore: () => set(initialState)
    }),
    {
      name: 'listing-stats',
      version: 1
    }
  )
);